<template>
  <div class="service-market-container">
    <div class="market-img-container">
      <div class="img-top-container">
        <div @click="goLink(item.link)"
             class="img-top-item"
             v-for="item in topImgList"
             :key="item.id">
          <img :src="item.image"
               alt="">
        </div>
      </div>
      <div class="img-bottom-container">
        <div @click="goLink(item.link)"
             class="item-bottom-item"
             v-for="item in botImgList"
             :key="item.id">
          <img :src="item.image"
               alt="">
        </div>
      </div>
    </div>
    <div class="market-goods-container">
      <el-tabs v-model="tabActiveName"
               class="goods-category-tab"
               @tab-click="categoryTabClick">
        <el-tab-pane v-for="item in categoryList"
                     :key="item.id"
                     :label="item.name"
                     :name="item.name"></el-tab-pane>
      </el-tabs>
      <div class="sub-category-container">
        <div class="sub-category-item"
             v-for="(item,index) in subCategoryList"
             :key="item.id"
             :class="{'active':subCategoryIndex===index}"
             @click="toClickSubCategory(item,index)">{{ item.name }}</div>
      </div>
      <div class="goods-list-container">
        <!-- big广告图 -->
        <div @click="goLink(item.link)"
             class="big-ad-img">
          <img :src="bigImgList.length > 0 ? bigImgList[0].image : ''"
               alt="">
        </div>
        <div class="goods-item-pagination">
          <div class="goods-item-container">
            <div v-if="goodsList.length"
                 v-for="item in goodsList"
                 :key="item.id"
                 class="goodslist-item">
              <GoodsItem :goods-info="item"
                         @toDetail="toGoodsDetail" />
            </div>
            <div class="goodslist-item placeholder"
                 v-if="goodsList.length % 4 !==0"
                 v-for="(item) in (4 - goodsList.length % 4)"
                 :key="item+'placeholder'"></div>
          </div>
          <div class="pagination-container">
            <el-pagination background
                           :hide-on-single-page="true"
                           layout="total,prev, pager, next"
                           :page-size="pageSize"
                           :total="total"
                           :current-page.sync="currentPage"
                           @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBanner, getGoodsCategory, getGoodsList } from "@/api/home"
import { mapState } from 'vuex'
import GoodsItem from "@/components/GoodsItem"
const subCategoryList = [{
  id: -1,
  name: '全部',
  pid: 0,
  level: 2
}]
export default {
  name: 'serviceMarket',
  components: { GoodsItem },
  data () {
    return {
      tabActiveName: '',
      categoryList: [],
      subCategoryList: [],
      subCategoryIndex: 0,
      categoryId: null,
      parentCategoryId: null,
      pageSize: 8, //每页显示条数
      currentPage: 1, // 当前页数
      total: 0, // 总条数
      goodsList: [],
      topImgList: [],
      botImgList: [],
      bigImgList: []
    }
  },
  computed:{
    ...mapState("goodsCategory",['goodsCategory','goodsSubCategory'])
  },
  created () {
    window.scrollTo(0, 0)
  },
  async mounted () {
    this.getGoodsList()
    await this.getTopList()
    await this.getBotList()
    await this.getBigList()
    this.$bus.$off('getGoodsListByCategory').$on('getGoodsListByCategory', data => {
      console.log('类型数据接收', this.subCategoryList,data);
      const categoryId = data.categoryId
      const categoryName = data.categoryName
      const categoryTempIndex = this.categoryList.findIndex(item=>item.id == categoryId)
      this.$store.commit('goodsCategory/SET_GOODSCATEGORY',null)
      this.$store.commit('goodsCategory/SET_GOODSSubCATEGORY',null)
      if(categoryTempIndex != -1) {
        this.$store.commit('goodsCategory/SET_GOODSCATEGORY',{
          name:categoryName,
          id:categoryId,
          index:categoryTempIndex
        })
      }else {
        const subCateTempIndex = this.subCategoryList.findIndex(item=>item.id == categoryId)
        const subCateTemp= this.subCategoryList.find(item=>item.id == categoryId)
        let parentCategory = null
        this.categoryList.forEach((item,index)=>{
          if(item.id == data.pid) {
            parentCategory = {
              ...item,
              index
            }
          }
        })
        this.$store.commit('goodsCategory/SET_GOODSSubCATEGORY',{
          subInfo:subCateTemp,
          subIndex:subCateTempIndex,
          parentCategory:parentCategory
        })
      }
    });
    await this.getGoodsCategory()
  },
  methods: {
    goLink (link) {
      window.open(link, '_blank')
    },
    async getTopList () {
      const { data } = await getBanner({
        type: 5
      })
      // console.log(data, 'getCooperationList')
      if (data.length) {
        this.topImgList = data
      }
    },
    async getBotList () {
      const { data } = await getBanner({
        type: 6
      })
      // console.log(data, 'getCooperationList')
      if (data.length) {
        this.botImgList = data
      }
    },
    async getBigList () {
      const { data } = await getBanner({
        type: 7
      })
      // console.log(data, 'getCooperationList')
      if (data.length) {
        this.bigImgList = data
      }
    },
    toGoodsDetail (item) {
      this.$router.push({
        name: 'GoodsDetail',
        params: {
          id: item.id + '.html'
        }
      })
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getGoodsList()
    },
    getGoodsList (params = {}) {
      // console.log(this.categoryId)
      getGoodsList({
        page: this.currentPage,
        size: this.pageSize,
        category_id: this.categoryId,
        ...params
      }).then(res => {
        if (res.data.data) {
          this.goodsList = res.data.data
        }
        this.total = res.data.total
      })
    },
    toClickSubCategory (item, index) {
      this.currentPage = 1
      this.subCategoryIndex = index
      if (item.name === '全部') {
        this.categoryId = this.parentCategoryId
      } else {
        this.categoryId = item.id
      }
      this.getGoodsList()
    },
    categoryTabClick (tab,needRequest=true) {
      this.currentPage = 1
      const tabIndex = +tab.index
      const categoryItem = this.categoryList[tabIndex]
      this.categoryId = this.parentCategoryId = categoryItem.id
      // console.log(this.categoryId)
      this.subCategoryList = categoryItem.children && categoryItem.children.length ? subCategoryList.concat(categoryItem.children) : subCategoryList
      if(needRequest) {
        this.subCategoryIndex = 0
        this.getGoodsList()
      }
    },
    async getGoodsCategory () {
      this.subCategoryList = []
      const result = await getGoodsCategory()
      // console.log(result)
      result.data.unshift({
        id: '',
        name: '全部',
      })
      this.categoryList = result.data ? result.data : []
      if(this.goodsCategory) {
        this.tabActiveName = this.goodsCategory.name
        this.categoryTabClick({
          index:this.goodsCategory.index,
          name:this.goodsCategory.name
        })
      }else if(this.goodsSubCategory){
        this.tabActiveName = this.goodsSubCategory.parentCategory.name
        this.categoryTabClick({
          index:this.goodsSubCategory.parentCategory.index,
          name:this.goodsSubCategory.parentCategory.name
        },false)
        this.toClickSubCategory(this.goodsSubCategory.subInfo,this.goodsSubCategory.subIndex)
      }else {
        this.tabActiveName = this.categoryList.length ? this.categoryList[0].name : ''
        this.categoryId = this.parentCategoryId = this.categoryList.length ? this.categoryList[0].id : null
        this.subCategoryList = this.categoryList.length && this.categoryList[0].children ? this.categoryList[0].children : []
        this.subCategoryList = subCategoryList.concat(this.subCategoryList)
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.service-market-container {
  width: 1200px;
  margin: 0 auto;
}
.market-img-container {
  margin-top: 25px;
}
.img-top-container {
  margin-bottom: 25px;
  display: flex;
}
.img-top-item {
  width: 589px;
  height: 223px;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.img-top-item:first-child {
  margin-right: 22px;
}
.img-bottom-container {
  display: flex;
  margin-bottom: 52px;
}
.item-bottom-item {
  width: 285px;
  height: 138px;
  border-radius: 10px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.item-bottom-item:not(:last-child) {
  margin-right: 20px;
}
.sub-category-container {
  margin-top: 22px;
  display: flex;
}
.sub-category-item {
  padding: 4px 36px;
  height: 28px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  line-height: 28px;
  font-size: 14px;
  font-weight: 400;
  color: @words;
  margin-right: 18px;
  cursor: pointer;
}
.sub-category-item:hover,
.sub-category-item.active {
  background: #e4f1ff;
  border: 1px solid @primary;
  color: @primary;
}
.goods-list-container {
  display: flex;
  margin-top: 29px;
}
.big-ad-img {
  width: 223px;
  height: 589px;
  border-radius: 10px;
  margin-right: 32px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    object-fit: cover;
  }
}
.goods-item-pagination {
  flex: 1;
}
.goods-item-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.goodslist-item {
  width: 212px;
  height: 292px;
  padding: 23px;
  background-color: transparent;
  border-radius: 20px;
  box-sizing: border-box;
}
.goodslist-item:hover {
  background-color: #fff;
}
.goodslist-item.placeholder {
  visibility: hidden;
}
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 65px;
  margin-bottom: 89px;
}
</style>
<style lang="less">
@import "~@/styles/var.less";
.goods-category-tab .el-tabs__item {
  font-size: 20px;
  font-weight: 600;
  color: @words;
}
.goods-category-tab .el-tabs__item.is-active {
  color: @primary;
}
</style>